import { useEffect, useState } from "react";
import { Avatar, Box, Button, Container, Divider, Grid, List, ListItem, ListItemAvatar, ListItemText, MenuItem, TextField, Typography } from "@mui/material";
import { checkTicket, GetTicketsSoldByEvent, GetTicketsSoldByEventPublic } from "../../../../controllers/company/EventsController";
import { useParams } from "react-router-dom/cjs/react-router-dom.min";
import QUDProgress from "../../../../components/progress";
import ResponseComponent from "../../../../components/responseComponent";
import { motion } from 'framer-motion';

import logoDigitel from '../../../../assets/images/allies/logoDigitel.svg';

export default function DigitelSorteo()
{
    const {id} = useParams();
    const [event,setEvent] = useState();
    const [tickets,setTickets] = useState([]);

    const [ticketStatus, setTitcketStatus] = useState('Todos');
    const [totalWinners,setTotalWinners] = useState('1');
    const [winners,setWinners] = useState([]);

    const [params,setParams] = useState('');
    const [auxTickets,setAuxTickets] = useState([]);

    

    const [isLoading,setIsLoading] = useState(false);
    const [open,setOpen] = useState(false);
    const [success,setSuccess] = useState(false);
    const [message,setMessage] = useState('');
    const [title,setTitle] = useState('');

    /*open : false,
    result : false, message : '', title : '',*/

    useEffect(()=>{
        handleGetTicketsSold();
    },[]);

    const handleGetTicketsSold = async () => {
        let response = await GetTicketsSoldByEventPublic(id);
        if(response.success === true)
        {
            setTickets(response.data.tickets);
        }
    }

    const handleCheckTicket = async (uuid,status) => {
        setIsLoading(true);
        let response = await checkTicket(uuid,status);
        if(response.success === true)
        {
            setSuccess(true);
            setMessage(response.message);
            setTitle('Operación Exitosa');
            setOpen(true);
            handleGetTicketsSold();
        }
        else{
            setSuccess(false);
            setMessage(response.message);
            setTitle('Operación Fallida');
            setOpen(true);
        }
        setIsLoading(false);
    }

    const handleClose = () => {
        /*if(success === true){
            handleGetTicketsSold()
        }*/
        setOpen(false)
    }

    const handleTotalWinnersChange = (event) => {
        const total = parseInt(event.target.value, 10);
        setTotalWinners(parseInt(isNaN(total) || total < 1 ? 1 : total).toString());
    };

    const realizarSorteo = async () => {
        if (!tickets || tickets.length === 0) {
            setWinners(['No hay tickets para sortear.']);
            return;
        }

        setWinners([]);
        setIsLoading(true);
        setTimeout(()=>{
            
            let ticketsFiltrados = tickets.filter(
                (ticket) =>
                    ticket.cliente !== 'Generico Generico' &&
                    ticket.cliente !== null &&
                    (ticketStatus === 'Todos' || ticket.estatus === ticketStatus)
                );
      
            if (ticketsFiltrados.length === 0) {
                setWinners([
                    `No hay tickets disponibles con el estatus "${ticketStatus}" y los criterios de cliente.`,
                ]);
                return;
            }
      
            const ganadoresSeleccionados = [];
            const pedidosGanadores = new Set();
        
            // Crear una copia del array de tickets filtrados para no modificar el original durante el bucle
            let ticketsRestantes = [...ticketsFiltrados];
        
            while (ganadoresSeleccionados.length < totalWinners && ticketsRestantes.length > 0) {
                const indiceAleatorio = Math.floor(Math.random() * ticketsRestantes.length);
                const ticketPotencial = ticketsRestantes[indiceAleatorio];
            
                if (!pedidosGanadores.has(ticketPotencial.codigo)) {
                    ganadoresSeleccionados.push(ticketPotencial);
                    pedidosGanadores.add(ticketPotencial.codigo);
                    // Filtrar los tickets restantes para excluir aquellos con el código de pedido del ganador actual
                    ticketsRestantes = ticketsRestantes.filter(
                    (ticket) => ticket.codigo !== ticketPotencial.codigo
                    );
                } else {
                    // Si el código de pedido ya fue ganador, simplemente removemos este ticket de los restantes
                    ticketsRestantes.splice(indiceAleatorio, 1);
                }
            
                // Seguridad adicional para evitar bucles infinitos si no quedan tickets únicos
                if (pedidosGanadores.size === ticketsFiltrados.length) {
                    break;
                }
            }
    
            if (ganadoresSeleccionados.length === 0) {
                setWinners(['No se pudieron seleccionar ganadores únicos según los criterios.']);
                return;
            }
        
            setWinners(
                ganadoresSeleccionados.map(
                    (ganador, index) => ganador
                )
            );
            setIsLoading(false);
        },5000);
    };

    return(
        <>
            <Grid container spacing={3} display={'flex'} justifyContent={'center'} alignItems={'center'} sx={{minHeight:'95vh'}}>
                <Grid item xs={12} sm={12} md={12} lg={12} xl={12} mt={12} display={'flex'} justifyContent={'center'}>
                    <Box style={{ width:'50%' }}>
                        {
                            isLoading === true
                            ?
                            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                <motion.img
                                    src={logoDigitel} // Reemplaza con la URL de tu imagen
                                    alt="Imagen con efecto de escala"
                                    style={{ width: '100%', height: 'auto', borderRadius: '10px' }}
                                    initial={{ scale: 1 }} // Estado inicial: tamaño normal
                                    animate={{ scale: [1, 1.2, 1] }} // Anima de 1 a 1.2 (más grande) y de vuelta a 1
                                    transition={{
                                    duration: 1.5, // Duración total de la animación (1.5 segundos)
                                    repeat: Infinity, // Repite la animación indefinidamente
                                    ease: "easeInOut" // Tipo de easing para una transición suave
                                    }}
                                />
                            </div>
                            :
                            <img
                                style={{width:'100%'}}
                                src={logoDigitel}
                                alt={'digitel-logo'}
                            />
                        }
                    </Box>
                </Grid>
                
                <Grid item xs={12} sm={12} md={12} lg={12} xl={12} display={'flex'} flexDirection={'column'} alignItems={'center'} justifyContent={'center'} sx={{mt:-5}}>
                    {
                            winners.length === 0
                            ?
                                isLoading === false
                                ?
                                <>
                                    <Button
                                        variant="contained"
                                        sx={{
                                            backgroundColor: '#4d2680',
                                            color: '#fff',
                                            height: '80px',
                                            width: '50%',
                                            //fontSize: '1.2rem',
                                            '&:hover': {
                                                backgroundColor: '#e62038',
                                                color: '#fff',
                                            },
                                        }}
                                        onClick={()=>realizarSorteo()}
                                    >
                                        <Typography variant="h3">
                                            Iniciar Sorteo
                                        </Typography>
                                    </Button>
                                </>
                                :null
                            :
                                <Grid container spacing={2} justifyContent={'center'}>
                                    <Grid item xs={12} lg={12} justifyContent={'center'} >
                                        <Grid container spacing={3} display={'flex'} justifyContent={'center'} alignItems={'center'}>
                                            <Grid item xs={12} lg={6} justifyContent={'center'} >
                                            <Typography textAlign={'center'} variant="h4">Ganador/a</Typography>
                                            <Divider/>
                                        </Grid>
                                        </Grid>
                                    </Grid>
                                    
                                    <Grid item xs={12} lg={6} justifyContent={'center'}>
                                        <List sx={{ width: '100%', bgcolor: 'background.paper' }}>
                                            {
                                                winners.map((item,index)=>
                                                    <>
                                                        <ListItem alignItems="center">
                                                            
                                                            <ListItemText
                                                                sx={{fontWeight:'bold',fontSize:30}}
                                                                primary={<Typography variant="h4" textAlign={'center'}>{`${item.cliente} - ${item.codigo}`}</Typography>}
                                                            />
                                                        </ListItem>
                                                    </>
                                                )
                                            }
                                        </List>
                                    </Grid>
                                </Grid>
                    }
                </Grid>
                
                 <Grid item xs={12} sm={12} md={12} lg={12} xl={12} mt={2}>
                    <Typography variant="body1" textAlign={'center'}>Powered by</Typography>
                    <Typography variant="h6" textAlign={'center'}>QUD.LIFE</Typography>
                </Grid>
            </Grid>

            {/*<QUDProgress open={isLoading}/>*/}
            <ResponseComponent
                show={open}
                success={success}
                title={title}
                message={message}
                actionText={'Aceptar'}
                onClick={()=>handleClose()}
            />
        </>
    )
}